import { createSelector } from 'reselect';
import { getUserZipCode } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { selectUserAkamaiZipcode, selectUserSigninSuccess } from './fromState';
import { selectFeatureFlags } from './ContextSelector';

const getUserAkamaiZipCode = createSelector(
    [selectUserAkamaiZipcode, selectFeatureFlags, selectUserSigninSuccess],
    (zipcode, featureFlags) => {
        if (!featureFlags || !featureFlags.enableAkamaiGeoZipCode) return null;
        if (!__SERVER__) return getUserZipCode() || zipcode.value;
        return null;
    }
);

export default getUserAkamaiZipCode;
